import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FacebookFormLogs } from 'src/app/core/models/social-forms-configurations/facebook-form-configuration.model';

@Component({
    selector: 'app-sidenav-content-facebook-form-log-item',
    templateUrl: './sidenav-content-facebook-form-log-item.component.html',
    styleUrls: ['./sidenav-content-facebook-form-log-item.component.scss'],
    standalone: false
})
export class SidenavContentFacebookFormLogItemComponent {
  @Input() log!: FacebookFormLogs


  @Output() selected = new EventEmitter()
  @Output() unselected = new EventEmitter()

  isSelected: boolean = false

  constructor() {
    this.selected.subscribe(() => this.isSelected = true)
    this.unselected.subscribe(() => this.isSelected = false)
  }


}
